import type { TrackingLabels } from '@shared/tracking/TrackingLabels';
export function getSelectionRulesTracking(
    rule: string,
    entryRule: string,
): Pick<TrackingLabels, 'wk.san_EntrySelectionRule' | 'wk.san_SelectionRule'> {
    return {
        'wk.san_EntrySelectionRule': entryRule,
        'wk.san_SelectionRule': rule,
    };
}
